define('bizzabo/TotangoAnalytics',[
    'underscore',
    'backbone',
    'bizzabo/config'
], function(
    _,
    Backbone,
    config
){

    var TotangoAnalytics = Backbone.Model.extend({
        initialize: function(options) {
            options = options || {};
            this.me = options.me;
            this.router = options.router;
            this.event = options.event;
            this.account = options.account;
            this.initTotango();
        },

        initTotango: function() {
            if (!config.TOTANGO_API_KEY) {
                return;
            }
            if (this.me && this.me.get('admin')) {
                return;
            }

            this.updateTotangoSettings();
            (function() {
                var tracker_name = window.totango_options.tracker_name || "totango";
                window.totango_tmp_stack = [];
                window[tracker_name] = {
                    go: function() {
                        return -1;
                    }, setAccountAttributes: function() {
                    }, identify: function() {
                    }, track: function(t, o, n, a) {
                        window.totango_tmp_stack.push({activity: t, module: o, org: n, user: a});
                        return -1;
                    }
                };
                var e = document.createElement('script');
                e.type = 'text/javascript';
                e.async = true;
                e.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'tracker.totango.com/totango3.js';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(e, s);
            })();

            if (this.me) {
                this.listenTo(this.me, 'change:id', _.bind(this.updateTotangoSettings, this));
            }
            if (this.event) {
                this.listenTo(this.event, 'change:id change:name', _.bind(this.updateTotangoSettings, this));
            }
            this.listenTo(Backbone, 'totango:trackEvent', function(name, module) {
                window.totango.track(name, module);
            });
            this.listenTo(Backbone, 'totango:updateSettings', function(options) {
                options = options || {};
                this.event = options.event;
                this.account = options.account;
                this.updateTotangoSettings();
            });
        },

        updateTotangoSettings: function() {
            window.totango_options = {
                service_id: config.TOTANGO_API_KEY
            };

            if (this.me && this.me.get('id')) {
                window.totango_options.user = {
                    id: this.me.get('id').toString(),
                    name: [
                        this.me.get('first-name'),
                        this.me.get('last-name')
                    ].join(' '),
                    firstName: this.me.get('first-name'),
                    lastName: this.me.get('last-name'),
                    email: this.me.get('primary-email')
                };
            }

            if (this.account && this.account.get('id')) {
                window.totango_options.account = {
                    id: this.account.get('id').toString(),
                    name: this.account.get('name'),
                    accountType: 'Account'
                };
            }

            window.totango && window.totango.go(totango_options);
        }

    });

    return TotangoAnalytics;
});

